import { localStorageTokenKey } from './repository'
import { fetchMessage } from './response_err_messages'
import { notificate } from './notification_service'

const requestInterceptor = {
  onConfig: (config, storage) => {
      config.headers = {
      "Authorization": storage.getItem(localStorageTokenKey)
    }
    return config
  },
  onError: err => Promise.reject(err)
}

const responseInterceptor = {
  onResponse: response => response.data,
  onError: (err, { auth, router, context }) => {
    if(!err.response) return Promise.reject(err)
      
    if(err.response.status === 401)
      auth.logout() .then(() => router.push("/login"))

    if (context)
      notificate(context, fetchMessage(err.response.status, context), 'danger', errorDetails(err.response))

    return Promise.reject(err)
  }
}

const errorDetails = ({ data }) => {
  try {
    const jsonData = typeof(data) == 'object' ? data : JSON.parse(data)
    return Object.keys(jsonData)
                 .map(key => jsonData[key])
                 .reduce((acc, array) => acc.concat(array), []) 
  }
  catch {
    return []
  }
}

export {
  requestInterceptor,
  responseInterceptor
}